import { defineMessages } from 'react-intl';

export default defineMessages({
    selectAddress: {
        id: 'platform.widgets.findaddress.components.FindAddress.Address Confirmation',
        defaultMessage: 'Address Confirmation'
    },
    keepAsEntered: {
        id: 'platform.widgets.findaddress.components.FindAddress.Keep as Entered',
        defaultMessage: 'Keep as Entered'
    },
    cancel: {
        id: 'platform.widgets.findaddress.components.FindAddress.Cancel',
        defaultMessage: 'Cancel'
    },
    editAddress: {
        id: 'platform.widgets.findaddress.components.FindAddress.Edit Address',
        defaultMessage: 'Edit Address'
    },
    noAddress: {
        id: 'platform.widgets.findaddress.components.FindAddress.The address you entered was not found.The address you entered was not found. Please either select Edit Address to make a correction or select Cancel and contact your agent for assistance.',
        defaultMessage: 'The address you entered was not found. Please either select Edit Address to make a correction or select Cancel and contact your agent for assistance.'
    },
    information: {
        id: 'platform.widgets.findaddress.components.FindAddress.Please select one of the following standardized addresses. If the correct address is not shown, please select Cancel and contact your agent for assistance.',
        defaultMessage: 'Please select one of the following standardized addresses. If the correct address is not shown, please select Cancel and contact your agent for assistance.'
    }
});
